import ForgotPassword from './ForgotPassword.vue'

export default ForgotPassword
